import { axios } from '@/plugins/axios';
import { FreightItem } from '@/models/quote-template';

export class QuoteFreightItemService {
  private endpoint: string;

  constructor() {
    this.endpoint = 'v1/quotes/templates/freights/';
  }

  async createQuoteFreight(freight: FreightItem) {
    return axios
      .post<FreightItem>(`${this.endpoint}`, freight)
      .then(({ data }) => data);
  }

  async fetchQuoteFreights(language = 'en') {
    return axios
      .get<FreightItem[]>(`${this.endpoint}`, {
        headers: {
          'Accept-Language': language
        }
      })
      .then(({ data }) => data);
  }

  async fetchQuoteFreight(id: number) {
    return axios
      .get<FreightItem>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  async updateQuoteFreight(freight: FreightItem) {
    return axios
      .patch<FreightItem>(`${this.endpoint}${freight.id}/`, freight)
      .then(({ data }) => data);
  }

  async deleteQuoteFreight(id: number) {
    return axios.delete(`${this.endpoint}${id}/`);
  }
}
